import React, { useEffect, useState } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import Service from "../Services/Service";
import "../styles/Sidebar.css";
import logo from "../Images/VMS.png";
import LogoutIcon from "@mui/icons-material/Logout";

// Import some icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";
//import GroupIcon from "@mui/icons-material/Group";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
//import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InventoryIcon from "@mui/icons-material/Inventory";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import BusinessIcon from "@mui/icons-material/Business";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import FolderIcon from "@mui/icons-material/Folder"; // fallback
import MailOutlineIcon from "@mui/icons-material/MailOutline";

import PublicIcon from "@mui/icons-material/Public"; // Region
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Religion
import EventIcon from "@mui/icons-material/Event"; // Holiday
import DescriptionIcon from "@mui/icons-material/Description"; // Template
import Tooltip from "@mui/material/Tooltip";

import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import OutgoingMailIcon from "@mui/icons-material/OutgoingMail";
import CelebrationIcon from "@mui/icons-material/Celebration";


import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import SummarizeIcon from "@mui/icons-material/Summarize";

import { startSession } from "../Utils/SessionManager";


function Sidebar({ collapsed, onCollapsedChange }) {
  const [menus, setMenus] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  // const [buttonText, setButtonText] = useState("Logout");

  let email = sessionStorage.getItem("userEmail");
  const location = useLocation();

  useEffect(() => {
    setOpenMenu(null);
    if (onCollapsedChange) {
      onCollapsedChange(true);
    }
  }, [location.pathname, onCollapsedChange]);

  const navigate = useNavigate();
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";

  // Map menu name / id → icon
  const iconMap = {
    Master: <SettingsIcon />, // general settings / master data
    Category: <ListAltIcon />, // list or categories
    Religion: <AccountBalanceIcon />,
    Region: <PublicIcon />,
    Holiday: <EventIcon />,
    Template: <DescriptionIcon />,
    Event: <CelebrationIcon />,
    "Private User": <AdminPanelSettingsIcon />,

    Registration: <HowToRegIcon />, // registration form
    "Vendor Registration": <BusinessIcon />, // vendor onboarding
    "Vendor Invitation": <MailOutlineIcon />, // invite vendors
    "User Management": <PeopleIcon />, // manage users
    "Group Creation": <GroupAddIcon />, // add groups
    "User Mapping": <PersonIcon />, // assign/map users
    "Role Mapping": <AssignmentIndIcon />, // assign roles
    Dashboard: <DashboardIcon />, // dashboard

    Report: <AssignmentIcon />, // reports
    "All Vendor": <InventoryIcon />, // all vendors list
    "Vendor Status": <VerifiedUserIcon />, // vendor approval/status
    "Vendor Approval": <HowToRegIcon />, // approval process
    "Card Scan": <CreditCardIcon />, // scanning card
    "Business Card Report": <SummarizeIcon />,

    "Vendor Engagement": <ConnectWithoutContactIcon />,//add icon here after import
    "Custom Mail": <OutgoingMailIcon />,//add icon here after import
    Default: <FolderIcon />, // fallback icon

    "Vendor Approval Status": <TaskAltIcon />,

    "Business Card": <PermContactCalendarIcon />,
  };

  // let vSource = "";
  // let vUsername = "";

  let vSource = "";
  let vRoleID = "";
  let vUsername = "";
  let vEmpName = "";


  // useEffect(() => {
  //   alert('Test');
  //   let queryParams = new URLSearchParams(location.search);
  //   // vUsername = queryParams.get("username");
  //   // vSource = queryParams.get("source");

  //   vUsername = queryParams.get("username");
  //   vRoleID = queryParams.get("roleid");
  //   vSource = queryParams.get("source");
  //   vEmpName = queryParams.get("empname");
  //   alert(vSource);

  //   if (vSource === "ERP") {
  //     //debugger;
  //     startSession();
  //     sessionStorage.setItem("TenantID", queryParams.get("TenantID"));
  //     sessionStorage.setItem("Source", queryParams.get("source"));
  //     setTimeout(() => {
  //       sessionStorage.setItem("APIUrl", "https://vmsapi.iecsl.in");
  //       //let username = vUsername;

  //       sessionStorage.setItem("isLoggedIn", "true");

  //      // ⭐ START VMS SESSION

  //       sessionStorage.setItem("userEmail", vUsername);
  //       sessionStorage.setItem("empname", vEmpName);
  //       sessionStorage.setItem("GroupId", vRoleID);
  //       email = sessionStorage.getItem("userEmail");

  //       // sessionStorage.setItem("isLoggedIn", "true");
  //       // sessionStorage.setItem("userEmail", vUsername);
  //       // email = sessionStorage.getItem("userEmail");

  //       if (sessionStorage.getItem("isLoggedIn") === "true") {
  //         navigate("/Dashboard", { replace: true });
  //       }

  //       // setButtonText("Go to Home");
  //     }, 100);
  //   } else {
  //     // setButtonText("Logout");
  //   }
  //   Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/RoleMapping");
  //   //Service.setApiUrl("https://localhost:7106/api/RoleMapping");
  //   loadMenus(email);
  // }, [email]);

  useEffect(() => {
    let queryParams = new URLSearchParams(location.search);
    // vUsername = queryParams.get("username");
    // vSource = queryParams.get("source");

    vUsername = queryParams.get("username");
    vRoleID = queryParams.get("roleid");
    vSource = queryParams.get("source");
    vEmpName = queryParams.get("empname");

    console.log("ERP Source:", vSource);
    console.log("ERP Username:", vUsername);
    console.log("ERP RoleID:", vRoleID);
    console.log("ERP Employee Name:", vEmpName);

    if (vSource === "ERP") {
      // =========================
      // ERP LOGIN
      // =========================

      startSession();

      sessionStorage.setItem("APIUrl", "https://vmsapi.iecsl.in");

      sessionStorage.setItem("isLoggedIn", "true");

      sessionStorage.setItem("userEmail", vUsername);

      sessionStorage.setItem("empname", vEmpName);

      const vEmpNo = queryParams.get("empno");
      if (vEmpNo) {
        sessionStorage.setItem("EmpNo", vEmpNo);
      }

      sessionStorage.setItem("GroupId", vRoleID);

      sessionStorage.setItem("TenantID", queryParams.get("TenantID"));
      // sessionStorage.setItem("Source", queryParams.get("source"));
      // setTimeout(() => {
      //    sessionStorage.setItem("APIUrl", "https://vmsapi.iecsl.in");
      //sessionStorage.setItem("APIUrl", "http://localhost:5211");

      //let username = vUsername;

      sessionStorage.setItem("Source", vSource);

      // sessionStorage.setItem("isLoggedIn", "true");
      // sessionStorage.setItem("userEmail", vUsername);
      // sessionStorage.setItem("empname", vEmpName);
      // sessionStorage.setItem("GroupId", vRoleID);
      // email = sessionStorage.getItem("userEmail");

      // =========================
      // GO TO DASHBOARD
      // =========================

      navigate("/DashboardFinal", {
        replace: true,
      });

      return;
    }

    // =========================
    // NORMAL VMS LOGIN
    // =========================

    const storedEmail = sessionStorage.getItem("userEmail");

    if (storedEmail) {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/RoleMapping");
      loadMenus(storedEmail);
    }
  }, [location.search, navigate]);

  const loadMenus = async (email) => {
    try {
      const res = await Service.loadSideBarMnus(email, "GetAllMnus", "W");
      console.log(res.data);

      // const res = await Service.loadSideBarMnus(email, "GetAllMnus");
      // console.log(res.data)
      const allMenus = res?.data?.table || [];
      console.log("ALL MENUS ", allMenus);

      //debugger;

      // const structuredMenus = allMenus

      //   .filter((m) => m.groupCode === 0 && m.mnuId !== 10 )
      //   .map((main) => ({
      //     ...main,
      //     children: allMenus.filter((m) => m.groupCode === main.mnuId),
      //   }));

      // const hiddenDashboardMenus = [
      //   "Average Cost Chart",
      //   "Purchase Analysis Chart",
      //   "Quality Purchase Chart",
      //   "Selling Plans Pie Chart",
      //   "Vendors Bar Chart",
      //   "Sales Orders",
      //   "Current Stock",
      //   "Product Sold",
      //   "Stock In",
      //   "Stock Out",
      //   "Stock Value",
      //   "To Be Delivered",
      //   "To Be Packed",
      //   "To Be Shipped",
      //   "New Vendors",
      // ];

      // const structuredMenus = allMenus
      //   .filter((m) => m.groupCode === 0)
      //   .map((main) => ({
      //     ...main,
      //     children: allMenus
      //       .filter((m) => m.groupCode === main.mnuId)
      //       .filter(
      //         (child) =>
      //           !(
      //             main.menuText === "Dashboard" &&
      //             hiddenDashboardMenus.includes(child.menuText)
      //           ),
      //       ),
      //   }));

      // setMenus(structuredMenus);



      //New 

      // ---------------------------------------------
      // BUILD MENU HIERARCHY
      // ---------------------------------------------

      const topMenus = allMenus.filter(
        (m) => m.groupCode === 0
      );

      // Dashboard
      const dashboard = topMenus.find(
        (m) => m.menuText === "Dashboard"
      );

      // Template1 / Template2 are children of Dashboard
      const dashboardChildren = dashboard
        ? allMenus.filter(
          (m) => m.groupCode === dashboard.mnuId
        )
        : [];


      // Dashboard children = ONLY Template1 and Template2
      // Do NOT attach charts/statistics here.
      const dashboardTemplates = dashboardChildren.map(
        (template) => ({
          ...template,
          children: [],
        })
      );


      // Remove Dashboard, Template1 and Template2
      // from top-level list because they are handled above
      const otherMenus = topMenus.filter(
        (m) =>
          m.menuText !== "Dashboard" &&
          !dashboardChildren.some(
            (child) => child.menuText === m.menuText
          )
      );

      // Build final sidebar
      const structuredMenus = [
        ...(dashboard
          ? [
            {
              ...dashboard,
              children: dashboardTemplates,
            },
          ]
          : []),

        ...otherMenus.map((main) => ({
          ...main,

          children: allMenus.filter(
            (child) => child.groupCode === main.mnuId
          ),
        })),
      ];

      console.log(
        "FINAL SIDEBAR MENUS",
        structuredMenus
      );

      setMenus(structuredMenus);

      sessionStorage.setItem(
        "ALL_MENUS",
        JSON.stringify(allMenus)
      );
      // ✅ IMPORTANT: store full menu
      sessionStorage.setItem("ALL_MENUS", JSON.stringify(allMenus));
    } catch (err) {
      //console.error("Error loading menus:", err);
      setMenus([]);
    }
  };

  // const toggleMenu = (mnuId) => {
  //   setOpenMenu(openMenu === mnuId ? null : mnuId);
  // };

  const toggleMenu = (mnuId) => {
    setOpenMenu(openMenu === mnuId ? null : mnuId);
  };

  // const handleLogout = () => {
  //   sessionStorage.removeItem("isLoggedIn");
  //   sessionStorage.clear();
  //   navigate("/login");
  // };


  //New
  const renderSubMenus = (children) => {
    if (!children || children.length === 0) {
      return null;
    }

    return (
      <ul className="submenu open">
        {children.map((sub) => {
          const subIcon =
            iconMap[sub.menuText] || iconMap.Default;

          return (
            <li
              key={sub.mnuId}
              className={
                location.pathname === sub.form
                  ? "active"
                  : ""
              }
            >
              {sub.form === "#" ? (
                <>
                  <div
                    className="menu-title"
                    onClick={() =>
                      toggleMenu(sub.mnuId)
                    }
                  >
                    {subIcon}
                    <span>{sub.menuText}</span>
                  </div>

                  {openMenu === sub.mnuId &&
                    renderSubMenus(sub.children)}
                </>
              ) : (
                <>
                  <Link to={sub.form}>
                    {subIcon}
                    <span>{sub.menuText}</span>
                  </Link>

                  {sub.children &&
                    sub.children.length > 0 &&
                    renderSubMenus(sub.children)}
                </>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div
      className={`sidebar d-flex flex-column ${collapsed ? "collapsed" : ""}`}
    >
      {/* Logo and Profile Section */}
      <div className="sidebar-top">
        <div className="sidebar-logo-container">
          <Tooltip title={collapsed ? "VMS" : ""} placement="right" arrow>
            <Link to="/DashboardFinal" className="sidebar-logo-box">
              <img src={logo} alt="VMS Logo" className="sidebar-logo-img" />
            </Link>
          </Tooltip>
        </div>
        {/* {!collapsed && (
          <>
            <div className="sidebar-divider"></div>
            <div className="sidebar-company-name">
              Mendine Pharmaceuticals<br />Pvt. Ltd.
            </div>
            <div className="sidebar-divider"></div>
          </>
        )} */}
      </div>

      {/* Main Menu */}
      <ul className="sidebar-menu flex-grow-1">
        {/* <li
          key="dashboardFinal"
          className={
            location.pathname === "/DashboardFinal"
              ? "active menu-item"
              : "menu-item"
          }
        >
         
        </li> */}

        {menus.map((menu) => {
          const menuIcon = iconMap[menu.menuText] || iconMap.Default;

          return (
            <li key={menu.mnuId} className="menu-item">
              {menu.form === "#" ? (
                // <div
                //   className={`menu-title ${
                //     openMenu === menu.mnuId ? "open" : ""
                //   }`}
                //   onClick={() => toggleMenu(menu.mnuId)}
                // >
                //   {menuIcon} <span>{menu.menuText}</span>
                // </div>
                // <div
                //   className={`menu-title ${
                //     openMenu === menu.mnuId ? "open" : ""
                //   }`}
                //   onClick={() => toggleMenu(menu.mnuId)}
                //   title={menu.menuText}
                // >
                //   {menuIcon} <span>{menu.menuText}</span>
                // </div>
                <Tooltip
                  title={collapsed ? menu.menuText : ""}
                  placement="right"
                  arrow
                >
                  <div
                    className={`menu-title ${openMenu === menu.mnuId ? "open" : ""
                      }`}
                    onClick={() => toggleMenu(menu.mnuId)}
                  >
                    {menuIcon}
                    <span>{menu.menuText}</span>
                  </div>
                </Tooltip>
              ) : (
                // <Link
                //   key={menu.mnuId}
                //   to={menu.form}
                //   className={location.pathname === menu.form ? "active" : ""}
                // >
                //   {menuIcon} <span>{menu.menuText}</span>
                // </Link>
                // <Link
                //   key={menu.mnuId}
                //   to={menu.form}
                //   className={location.pathname === menu.form ? "active" : ""}
                //   title={menu.menuText}
                // >
                //   {menuIcon} <span>{menu.menuText}</span>
                // </Link>

                <Tooltip
                  title={collapsed ? menu.menuText : ""}
                  placement="right"
                  arrow
                >
                  <Link
                    key={menu.mnuId}
                    to={menu.form}
                    className={location.pathname === menu.form ? "active" : ""}
                  >
                    {menuIcon}
                    <span>{menu.menuText}</span>
                  </Link>
                </Tooltip>
              )}

              {/* Submenus */}
              {/* {menu.children && menu.children.length > 0 && (
                <ul
                  className={`submenu ${openMenu === menu.mnuId ? "open" : ""}`}
                >
                  {menu.children.map((sub) => {
                    const subIcon = iconMap[sub.menuText] || iconMap.Default;

                    return (
                      <li
                        key={sub.mnuId}
                        className={
                          location.pathname === sub.form ? "active" : ""
                        }
                      >
                        <Link to={sub.form}>
                          {subIcon} <span>{sub.menuText}</span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )} */}

              {/* New */}


              {menu.children &&
                menu.children.length > 0 &&
                openMenu === menu.mnuId &&
                renderSubMenus(menu.children)}
            </li>
          );
        })}
      </ul>

      {/* Action Button */}
      {/* <button className="sidebar-action-btn">
        <span>+</span>
        {!collapsed && "Add New Task"}
      </button> */}

      {/* Logout Button */}
      {/* {isLoggedIn && (
        <button className="logout-btn" onClick={handleLogout}>
          <LogoutIcon />
          {!collapsed && <span className="logout-text">Logout</span>}
        </button>
      )} */}
    </div>
  );
}

export default Sidebar;
